export default {
      id: "arrow-bottom-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#arrow-bottom",
      toString: function () {
        return this.url;
      }
    }